module.exports = __webpack_public_path__ + "static/media/attachedDocs.d4fdf220.svg";